import { useState } from "react";
import RenameBuildChapterModal from "./RenameBuildChapterModal";

function BuildChapterManager({
  car,
  onClose,
  onStartNewChapter,
  onSwitchChapter,
  onRenameChapter
}) {
    const [renameStage, setRenameStage] = useState(null);
  const stages = car.stages || [];
  const currentStage =
    stages.find((stage) => stage.id === car.currentStageId) || stages[0];

  const displayStageName = (stage) => {
    if (!stage?.name || stage.name === "Current Build") {
      return "Original Build Phase";
    }

    return stage.name;
  };

 return (
  <>
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <h2 style={{ marginTop: 0 }}>Build Phases</h2>

        <p style={textStyle}>
          Manage the different chapters of this build. Each chapter preserves a
          version of the car over time.
        </p>

        <div style={currentBoxStyle}>
          <div style={sectionHeaderStyle}>CURRENT</div>
          <strong>{displayStageName(currentStage)}</strong>
        </div>

        <div style={chapterListStyle}>
          <div style={sectionHeaderStyle}>HISTORY</div>

         {[...stages]
  .filter((stage) => stage.id !== car.currentStageId)
  .reverse()
  .map((stage) => (
              <div key={stage.id} style={chapterItemStyle}>
                <span>{displayStageName(stage)}</span>

                <div style={chapterActionsStyle}>
                  <button
                    type="button"
                    onClick={() => setRenameStage(stage)}
                    style={switchButtonStyle}
                  >
                    Rename
                  </button>

                  <button
                    type="button"
                    onClick={() => onSwitchChapter(stage.id)}
                    style={switchButtonStyle}
                  >
                    Make Current
                  </button>
                </div>
              </div>
            ))}

          {stages.filter((stage) => stage.id !== car.currentStageId).length ===
            0 && <p style={emptyTextStyle}>No previous chapters yet.</p>}
        </div>

        <button onClick={onStartNewChapter} style={primaryButtonStyle}>
          + Start New Build Phase
        </button>

        <button onClick={onClose} style={secondaryButtonStyle}>
          Close
        </button>
      </div>
    </div>

    <RenameBuildChapterModal
      isOpen={!!renameStage}
      currentName={displayStageName(renameStage)}
      onCancel={() => setRenameStage(null)}
      onSave={async (newName) => {
        await onRenameChapter(renameStage.id, newName);
        setRenameStage(null);
      }}
    />
  </>
);
}

const overlayStyle = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0,0,0,0.82)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 30000,
  padding: "20px"
};

const modalStyle = {
  backgroundColor: "#181818",
  border: "1px solid #333",
  borderRadius: "20px",
  padding: "22px",
  maxWidth: "420px",
  width: "100%",
  boxSizing: "border-box",
  color: "white"
};

const textStyle = {
  opacity: 0.8,
  lineHeight: "1.6"
};

const currentBoxStyle = {
  backgroundColor: "#1f1f1f",
  border: "1px solid #333",
  borderRadius: "14px",
  padding: "14px",
  marginTop: "16px"
};

const labelStyle = {
  fontSize: "12px",
  opacity: 0.7,
  marginBottom: "4px"
};

const chapterListStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  marginTop: "18px",
  marginBottom: "18px"
};

const chapterItemStyle = {
  backgroundColor: "#1f1f1f",
  border: "1px solid #2a2a2a",
  borderRadius: "12px",
  padding: "12px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "12px"
};

const switchButtonStyle = {
  backgroundColor: "#333",
  color: "white",
  border: "1px solid #444",
  borderRadius: "8px",
  padding: "8px 10px",
  fontWeight: "bold",
  cursor: "pointer"
};

const primaryButtonStyle = {
  width: "100%",
  backgroundColor: "#e10600",
  color: "white",
  border: "none",
  borderRadius: "12px",
  padding: "14px",
  fontWeight: "bold",
  cursor: "pointer"
};

const secondaryButtonStyle = {
  width: "100%",
  backgroundColor: "#333",
  color: "white",
  border: "none",
  borderRadius: "12px",
  padding: "14px",
  fontWeight: "bold",
  cursor: "pointer",
  marginTop: "10px"
};

const sectionLabelStyle = {
  fontSize: "12px",
  opacity: 0.7,
  fontWeight: "bold",
  textTransform: "uppercase",
  letterSpacing: "0.5px"
};

const emptyTextStyle = {
  opacity: 0.6,
  fontSize: "14px",
  margin: 0
};

const chapterActionsStyle = {
  display: "flex",
  gap: "8px",
  flexWrap: "wrap",
  justifyContent: "flex-end"
};

const sectionHeaderStyle = {
  fontSize: "12px",
  letterSpacing: "1.2px",
  fontWeight: "bold",
  color: "#888",
  marginBottom: "6px"
};

export default BuildChapterManager;